import { defineStore } from 'pinia'

export default defineStore({
  id: 'guest',
  persist: true,
  state: () => {
    return {
      guestId: '',
      contactName: '',
      contactPhone: '',
      contactEmail: '',
      commodityName: '',
      goodsWeight: 0,
      goodsDescription: ''
    }
  },
  actions: {
    clear: function () {
      this.guestId = ''
      this.contactName = ''
      this.contactPhone = ''
      this.contactEmail = ''
      this.commodityName = ''
      this.goodsWeight = 0
      this.goodsDescription = ''
    },
    setGuestInfo: function (payload: any) {
      const { guestId, contactName, contactPhone, contactEmail, commodityName, goodsWeight, goodsDescription } = payload || {}

      this.guestId = guestId
      this.contactName = contactName
      this.contactPhone = contactPhone
      this.contactEmail = contactEmail
      this.commodityName = commodityName
      this.goodsWeight = goodsWeight
      this.goodsDescription = goodsDescription
    },
    setGuestId: function (id: string) {
      this.guestId = id
    },
    setContactName: function (name: string) {
      this.contactName = name
    },
    setContactPhone: function (phone: string) {
      this.contactPhone = phone
    },
    setContactEmail: function (email: string) {
      this.contactEmail = email
    },
    setCommodityName: function (name: string) {
      this.commodityName = name
    },
    setGoodsWeight: function (weight: number) {
      this.goodsWeight = weight
    },
    setGoodsDescription: function (desc: string) {
      this.goodsDescription = desc
    }
  },
  getters: {
    getGuestId: (state) => state.guestId,
    getContactName: (state) => state.contactName,
    getContactPhone: (state) => state.contactPhone,
    getContactEmail: (state) => state.contactEmail,
    getCommodityName: (state) => state.commodityName,
    getGoodsWeight: (state) => state.goodsWeight,
    getGoodsDescription: (state) => state.goodsDescription
  }
})
